import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import Constants from "../../../util/Constants";
import DailySalesReportAPI from "../../../api/DailySalesReportAPI";
import { Button, Table } from "react-bootstrap";
import { CSVLink } from "react-csv";
import { FaFilter } from "react-icons/fa";
import ReactApexChart from "react-apexcharts";
import FilterPannel from "../../filter/FilterPannel";


class ConsolidatedActivityReport extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      totalCounts: { email: 0, whatsapp: 0, task: 0, call: 0, sms: 0, meeting: 0, contact: 0 },
      alert: null,
      title: "Consolidated_Activity_Report",
      isFilterOpen: true,
      filters: [
      {
        "field": "created_date",
        "condition": "in",
        "value": "2021-12-31 18:30:00~2025-01-31 18:29:59"
      }]
    };
    this.fields = reactLocalStorage.getObject(Constants.Model)?.call?.fields;
    this.filteredFields = Object.keys(this.fields).filter((kr)=>kr === "created_by" || kr === "created_date").map((ke)=>this.fields[ke])
    this.users = reactLocalStorage.getObject(Constants.Model)?.user?.options || [];
  }

  componentDidMount() {
    this.fetchConsolidatedData(this.state.filters);
  }

  fetchConsolidatedData = (filters) => {
    const body = {
      filters:  filters 
    };
    DailySalesReportAPI.getFixedConsolidatedReport(body, this.handleReceivedData, this.handleFail);
  };
  

  handleReceivedData = (response) => {
    if (Array.isArray(response)) {
      const totalCounts = response.reduce(
        (totals, { email_count, whatsapp_count, task_count, call_count, sms_count, meeting_count, contact_count }) => ({
          email: totals.email + email_count,
          whatsapp: totals.whatsapp + whatsapp_count,
          // task: totals.task + task_count,
          call: totals.call + call_count,
          sms: totals.sms + sms_count,
          meeting: totals.meeting + meeting_count,
          contact: totals.contact + contact_count,
        }),
        { email: 0, whatsapp: 0, task: 0, call: 0, sms: 0, meeting: 0, contact: 0 }
      );

      this.setState({ data: response, totalCounts });
    }
  };

  handleFail = (error) => {
    this.setState({ alert: 'Failed to fetch Consolidated Activity data.' });
    console.error('Error:', error);
  };

  onFilterChange = (updatedFilters) => {
    this.setState({ filters: updatedFilters }, this.fetchConsolidatedData(updatedFilters));
  };

  getUserData = () => {
    const { data } = this.state;
    const mappedData = data.reduce((acc, { created_by, email_count, whatsapp_count, call_count, sms_count, meeting_count, contact_count }) => {
      acc[created_by] = { email_count, whatsapp_count, call_count, sms_count, meeting_count, contact_count };
      return acc;
    }, {});

    return this.users.map((user) => {
      const activityData = mappedData[user.value] || { email_count: 0, whatsapp_count: 0,  call_count: 0, sms_count: 0, meeting_count: 0, contact_count: 0 };

      return {
        id: user.value,
        name: user.name,
        ...activityData,
      };
    });
  };

  prepareChartData = (userData) => {
    const categories = userData.map(user => user.name);
    const series = [
      { name: 'Email', data: userData.map(user => user.email_count) },
      { name: 'WhatsApp', data: userData.map(user => user.whatsapp_count) },
      // { name: 'Tasks', data: userData.map(user => user.task_count) },
      { name: 'Calls', data: userData.map(user => user.call_count) },
      { name: 'SMS', data: userData.map(user => user.sms_count) },
      { name: 'Meetings', data: userData.map(user => user.meeting_count) },
      { name: 'Contacts', data: userData.map(user => user.contact_count) }
    ];

    return {
      options: {
        chart: {
          type: 'bar',
          stacked: true,
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        xaxis: {
          categories,
        },
        legend: {
          position: 'top',
        },
        fill: {
          opacity: 1,
        },
        title: {
          text: 'Consolidated Activity Report',
          align: 'center',
        },
      },
      series,
    };
  }

  toggleFilter = () => {
    this.setState((prevState) => ({
      isFilterOpen: !prevState.isFilterOpen,
    }));
  }

  render() {
    const { totalCounts,  title, isFilterOpen } = this.state;
    const userData = this.getUserData();
    const chartData = this.prepareChartData(userData);
const table = <Table >
     <thead>
       <tr>
         <th>Sales Executive</th>
         <th>Email (Sent)</th>
         <th>WhatsApp (Sent)</th>
         {/* <th>Tasks Completed</th> */}
         <th>Calls</th>
         <th>SMS Sent</th>
         <th>Meetings </th>
         <th>Contacts</th>
       </tr>
     </thead>
     <tbody>
       {userData.map((user) => (
         <tr key={user.id}>
           <td>{user.name}</td>
           <td>{user.email_count}</td>
           <td>{user.whatsapp_count}</td>
           {/* <td>{user.task_count}</td> */}
           <td>{user.call_count}</td>
           <td>{user.sms_count}</td>
           <td>{user.meeting_count}</td>
           <td>{user.contact_count}</td>
         </tr>
       ))}
       <tr>
         <td><strong>Total</strong></td>
         <td><strong>{totalCounts.email}</strong></td>
         <td><strong>{totalCounts.whatsapp}</strong></td>
         {/* <td><strong>{totalCounts.task}</strong></td> */}
         <td><strong>{totalCounts.call}</strong></td>
         <td><strong>{totalCounts.sms}</strong></td>
         <td><strong>{totalCounts.meeting}</strong></td>
         <td><strong>{totalCounts.contact}</strong></td>
       </tr>
     </tbody>
   </Table>
    return (

      // <ApiUiController inApiCall={false}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-6">
                  <h1>Consolidated Activity Report</h1>
                </div>
                <div className="col-md-6">
                  <CSVLink data={userData} filename={`${title.toLowerCase()}_report.csv`}>
                    <Button className="buttons btn-success">Export</Button>
                  </CSVLink>
                </div>
              </div>
            </div>
            <div className="col-md-4 pt-1">
              <div className="row filterrow">
                <div className="col-md-12 lastcol">
                  <div className="m-right">
                    <div className="btn btn-lead btn-sm filter-button" onClick={this.toggleFilter}>
                      <FaFilter />
                      <span className="badge badge-danger badge-mini rounded-circle">
                        {this.state.filters.length}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row pt-3">
            <div className="container-fluid">
              <div className="row">
                <div className={`col-md-${isFilterOpen ? 9 : 12}`}>
                 <ReactApexChart
            options={chartData.options}
            series={chartData.series}
            type="bar"
            height={350}
          />
                  <div className="col-md-12">{table}</div>
                 </div>
                 {isFilterOpen && (
                  <FilterPannel
                  filters={this.state.filters}
                  fields={this.filteredFields}
                  onFilterChange={this.onFilterChange}
                  isFilterOpen={isFilterOpen}
                  restrict={false}
                />
              )}
              </div>
             </div>
           </div>
         </div>
    );
  }
}

export default ConsolidatedActivityReport;

